import { Menu } from "lucide-react";
import { StatusBadge } from "@/components/layout/StatusBadge52";
import { LangMenu, UserMenu } from "@/components/layout/ShellMenus";
import { useT52 } from "@/i18n/v52";

export function Topbar({ title, menuOpen, onMenu, menuBtnRef, badgeRef }) {
  const { t52 } = useT52();
  return (
    <header className="f52-topbar" data-testid="app-topbar">
      <button ref={menuBtnRef} type="button" className="f52-icon-btn f52-menu-btn" onClick={onMenu}
        aria-label={t52("menu")} aria-controls="control-drawer" aria-expanded={menuOpen} data-testid="mobile-menu-button">
        <Menu aria-hidden="true" />
      </button>
      <span className="f52-tb-title" data-testid="topbar-title">{title}</span>
      <div className="f52-tb-right">
        <StatusBadge badgeRef={badgeRef} />
        <LangMenu />
        <UserMenu />
      </div>
    </header>
  );
}
